import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { WeakCharactersResponse } from "../types/domain";

export function useWeakCharacters() {
  return useQuery<WeakCharactersResponse["data"]>({
    queryKey: ["weak-characters"],
    queryFn: async () => {
      return api<WeakCharactersResponse["data"]>("/practice/weak-characters", { method: "GET" });
    },
  });
}
